import React from "react";
import Icon from "../ui/Icon";
import LiveKitVideo from "../ui/LiveKitVideo";

/* local copy for now (we'll move to utils later without behavior change) */
const AVATAR_GRADIENTS = [
  ["#4ADE80", "#16A34A"],
  ["#38BDF8", "#0284C7"],
  ["#FCD34D", "#D97706"],
  ["#C084FC", "#7C3AED"],
  ["#FB7185", "#BE123C"],
  ["#FB923C", "#C2410C"],
  ["#34D399", "#059669"],
  ["#A78BFA", "#5B21B6"],
];

const getAvatarColors = (name = "") => {
  if (!name || typeof name !== "string") return AVATAR_GRADIENTS[0];
  return AVATAR_GRADIENTS[name.charCodeAt(0) % AVATAR_GRADIENTS.length];
};

export default function FullscreenParticipantModal({
  open,
  participant,
  onClose,
}) {
  if (!open || !participant) return null;

  const {
    name,
    image,
    role,
    isMuted,
    isSpeaking,
    isLocal,
    hasVideo,
    trackRef,
  } = participant;

  const roleLabel =
    role === "host" ? "Host" : role === "speaker" ? "Speaker" : null;

  const roleColor =
    role === "host"
      ? "var(--jt-gold)"
      : role === "speaker"
        ? "var(--jt-purple)"
        : "var(--jt-accent)";

  const [c1, c2] = getAvatarColors(name);

  return (
    <div
      className="jt-modalOverlay"
      role="dialog"
      aria-modal="true"
      onMouseDown={onClose}
    >
      <div className="jt-fsCard" onMouseDown={(e) => e.stopPropagation()}>
        <button className="jt-fsClose" onClick={onClose} aria-label="Close">
          <Icon name="close" />
        </button>

        <div className="jt-fsMedia">
          {hasVideo && trackRef ? (
            <LiveKitVideo
              trackRef={trackRef}
              muted={isLocal}
              mirror={isLocal}
              objectFit="contain"
              className="jt-fsVideo"
            />
          ) : (
            <div
              className="jt-fsAvatar"
              style={{ background: `linear-gradient(135deg, ${c1}, ${c2})` }}
            >
              {image ? (
                <img src={image} alt="" />
              ) : (
                <span>{(name?.[0] || "?").toUpperCase()}</span>
              )}
              <div className="jt-fsCamOffPill">Camera is off</div>
            </div>
          )}

          <div className="jt-fsInfoBar">
            <div className="jt-fsLeft">
              {roleLabel && (
                <div
                  className="jt-rolePill"
                  style={{ borderColor: roleColor, color: roleColor }}
                >
                  {roleLabel}
                </div>
              )}
              <div className="jt-fsName">{name}</div>
            </div>
            <div className="jt-fsRight">
              {isSpeaking && <div className="jt-chip speaking">Speaking</div>}
              {isMuted ? (
                <div className="jt-chip muted">Muted</div>
              ) : (
                <div className="jt-chip live">Live</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
